import {
    ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Injectable, Input, OnChanges,
    Output
} from '@angular/core';

@Component({
    selector: 'ng2-tab',
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: `
        <div class="tab" [class.active]="active">
            <ng-content></ng-content>
        </div>
    `,
    styles: [`
        .tab {
            display: none;
        }
        .tab.active {
            display: block;
        }
    `]
})

export class TabComponent implements OnChanges {
    @Input() active = false;
    @Input() title = '';

    @Output() changeStatus = new EventEmitter();
    /*
    * Скрытые табы не отображаются для выбора
    * */
    @Input() hidden = false;

    constructor(
        private cd: ChangeDetectorRef
    ) {}

    ngOnChanges() {
        this.changeStatus.emit();
    }

    public updateView() {
        this.changeStatus.emit();
        this.cd.detectChanges();
    }
}
